import { testimonials } from "../data/homeData";
import rook from "../assets/images/rook.png";

const Testimonials = () => {
  return (
    <section className="section light-bg-testimonials testimonials">
      
      {/* Decorative rook */}
      <img
        src={rook}
        alt="Chess Rook"
        className="testimonials-rook"
      />

      <div className="section-header">
        <h2>Student - Parent Review</h2>
      </div>

      <div className="card-grid">
        {testimonials.map((t, index) => (
          <div className="review-card" key={index}>
            <div className="review-header">
              <strong>{t.name}</strong>
              <span className="rating">
                {"⭐".repeat(t.rating)}
              </span>
            </div>

            <p className="review-text">{t.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
